import React, { Component } from "react";
import './navbar.css';
import Scrollspy from 'react-scrollspy'
import { Link } from 'react-scroll'
import { FormattedMessage } from 'react-intl';

class Navbar extends Component {

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if (document.documentElement.scrollTop > 0) {
      this.refs.logo.classList.add('site-logo-navbar')
      this.refs.nav.classList.add('navbar-scolled')
    } else {
      this.refs.logo.classList.remove('site-logo-navbar')
      this.refs.nav.classList.remove('navbar-scolled')
    }
  };

  render() {
    return (
      <nav ref="nav" className="navbar navbar-expand-lg fixed-top navbar-light">
        <Link className="site-logo-link" to="home" smooth={true} duration={500} >
          <img ref="logo" src="img/logo.png" className="site-logo" alt="Logo" />
        </Link>

        <button className="navbar-toggler ml-auto" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse navbar-nav ml-auto" id="navbarSupportedContent">
          <Scrollspy className="navbar-nav ml-auto" items={['home', 'about', 'engagements', 'weddings', 'bespoke', 'contact']} offset={-75} currentClassName="active">
            <li className="nav-item hidden">
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="about" smooth={true} duration={500} offset={-74} ><FormattedMessage id={'navbar.about'} /></Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="engagements" smooth={true} duration={500} offset={-74} ><FormattedMessage id={'navbar.engagements'} /></Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="weddings" smooth={true} duration={500} offset={-74}><FormattedMessage id={'navbar.weddings'} /></Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="bespoke" smooth={true} duration={500} offset={-74}><FormattedMessage id={'navbar.bespoke'} /></Link>
            </li>
            <li className="nav-item-contact">
              <div className="nav-item-contact-border">
                <Link className="nav-link" to="contact" smooth={true} duration={500} offset={-74}><FormattedMessage id={'navbar.contact'} /></Link>
              </div>
            </li>
          </Scrollspy>
        </div>
      </nav >
    );
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/navbar/navbar.js